<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- 불량원인 -->
							<th class="col-1">{{ getMessage_('QWCC001453') }}</th>
							<!-- <td colspan="3">
								<el-input
									type="textarea"
									:rows="3"
									:value="detailForm.badCausSbc"
									@input="value => onChangeParam_text('badCausSbc', value, 200)"
									:readonly="overInspect"
								/>
							</td> -->
							<td colspan="3">
								<el-input
									type="textarea"
									:rows="3"
									:value="detailForm.badCausSbc"
									@input="value => onChangeParam_text('badCausSbc', value, 200)"
									:readonly="onChkMdvRplCd"
								/>
							</td>
							<!-- 개선대책 -->
							<th class="col-1">{{ getMessage_('QWCC001443') }}</th>
							<td colspan="5">
								<el-input
									type="textarea"
									:rows="3"
									:value="detailForm.bttmMdvSbc"
									@input="value => onChangeParam_text('bttmMdvSbc', value, 200)"
									:readonly="onChkMdvRplCd"
								/>
							</td>
						</tr>
						<tr>
							<!-- 불량원인 파일첨부 -->
							<th class="col-1">{{ getMessage_('QWCC000039') }}</th>
							<td>
								<template v-if="isLoaded">
									<file-upload-list
										id="badCausFile"
										ref="badCausFileRef"
										width="100%"
										height="100%"
										:propFileList="detailForm.badCausFileDb"
										:isEditable="!onChkMdvRplCd"
										maxQuantity="5"
										@MultiFile="causFileUpload"
										@onDownload="onDownloadFileGlims"
									></file-upload-list>
								</template>
							</td>
							<!-- 개선LOT -->
							<th class="col-1">{{ getMessage_('QWCC001454') }}</th>
							<td><el-input v-model="detailForm.bttmLotNo" :readonly="onChkMdvRplCd" /></td>
							<!-- 대책일자 -->
							<th class="col-1">{{ getMessage_('QWCC001444') }}</th>
							<td>
								<el-date-picker
									v-model="detailForm.mdvDd"
									type="date"
									format="yyyy-MM-dd"
									value-format="yyyyMMdd"
									:disabled="onChkMdvRplCd"
								/>
							</td>
							<!-- 고품처리 -->
							<th class="col-1">{{ getMessage_('QWCC001455') }}</th>
							<td>
								<sf-select-group
									labelPosition="left"
									:inputValue="detailForm.rptpPrcsCd"
									:options="getRptpPrcsCdList_"
									:onChange="value => onChangeParam({ key: 'rptpPrcsCd', value })"
									:disabled="onChkMdvRplCd"
								/>
							</td>
							<!-- 작성자 -->
							<th class="col-1">{{ getMessage_('QWCC001382') }}</th>
							<td><el-input v-model="detailForm.mdvPprrNm" readOnly /></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { getLimitedByteText } from '@/qmsUtils';
import FileUploadList from '@qms/Components/FileUploadList.vue';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PrtRpt/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' },
		flgOsGrp: { type: Boolean, default: false }, // 총괄사용자그룹
		flgPqyapGrp: { type: Boolean, default: false }, //승인자그룹
		flgPqyrvGrp: { type: Boolean, default: false }, //검토자그룹
		flgPqyrgGrp: { type: Boolean, default: false }, //작성자그룹
		flgPqycpGrp: { type: Boolean, default: false } //외부(협력업체) 그룹
	},
	data() {
		return {
			isLoaded: false
		};
	},
	async created() {
		this.isLoaded = true;
	},
	components: { FileUploadList },
	computed: {
		...rootComputed,
		...serviceComputed,
		overInspect() {
			return false;
			// 임시저장, 반려, 등록 상태 일 때,
			//return Number(this.detailForm.pgsStCd) >= 30 || this.detailForm.ssId !== this.detailForm.rgnId;
		},
		finAllStep() {
			return Number(this.detailForm.pgsStCd) >= 40;
		},
		// 대책회신 기준으로 활성화, 비활성화
		onChkMdvRplCd() {
			const { mdvRplCd, pgsStCd, partGCd } = this.detailForm; //대책회신 , 진행상태, 소싱구분
			
			// if (partGCd === 'V') {
			// 	if (mdvRplCd === 'RPL10') {
			// 		//회신필요일경우
			// 		if (pgsStCd !== undefined && pgsStCd === '30' && this.flgPqycpGrp) {
			// 			// 승인 상태일때
			// 			return false;
			// 		} else if (this.flgOsGrp || this.flgPqyapGrp) {
			// 			return false;
			// 		} else {
			// 			return true;
			// 		}
			// 	} else {
			// 		//회신 불필요일경우
			// 		return true;
			// 	}
			// } else {
			// 	return true;
			// }
				if (mdvRplCd === 'RPL10') {
					//회신필요일경우
					if (pgsStCd !== undefined && pgsStCd === '30' && partGCd ==='V') {
						// 승인 상태일때
						return false;
					} else if (this.flgOsGrp || this.flgPqyapGrp) {
						return false;
					} else {
						return true;
					}
				} else {
					//회신 불필요일경우
					return true;
				}
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async onDownloadFile(file) {
			const { fileId, fileSeq } = file;
			await this.fileDownload_({ fileId, fileSeq });
		},
		async onDownloadFileGlims(file) {
			const { fileId, fileSeq } = file;
			await this.fileDownloadGlims_({ fileId, fileSeq });
		},
		causFileUpload(saveList) {
			this.onChangeParam_({ key: 'badCausFile', value: saveList });
		},
		onChangeParam_text(key, value, maxByte) {
			maxByte ? this.onChangeParam({ key, value: getLimitedByteText(value, maxByte) }) : this.onChangeParam({ key, value });
		},
		onChangeParam(payload) {
			this.$sf_toggleLoading(true);
			this.onChangeParam_(payload)
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => this.$sf_toggleLoading(false));
		}
	}
};
</script>

<style></style>
